export default {
  routerList: [
    {
      path: '/jsyjhHome',
      component: () => import('@/views/jsyjh/home/homePage.vue'),
      name: '建设研究会主页',
      children: []
    },
    {
      path: '/jsyjhList',
      component: () => import('@/views/jsyjh/home/newList.vue'),
      name: '建设研究会新闻列表',
      children: []
    },
    {
      path: '/jsyjhDetails',
      component: () => import('@/views/jsyjh/home/newDetails.vue'),
      name: '建设研究会新闻详情',
      children: []
    },
      {
      path: '/jsyjhSearch',
      component: () => import('@/views/jsyjh/home/search.vue'),
      name: '搜索',
      children: []
    },

  ]
}
